import { FC, memo } from 'react';

import { EFinalStatuses, finalContentByStatus, IStepComponentProps } from 'components/ImportCsv/constants';
import { FinalStepStyled } from 'components/ImportCsv/styled';

const FinalStep: FC<Partial<IStepComponentProps>> = () => {
  const finalStatus = EFinalStatuses.Success;

  return <FinalStepStyled>{finalContentByStatus[finalStatus]}</FinalStepStyled>;
};

export default memo(FinalStep);
